$(".js-stage-slider").length && $(".js-stage-slider").slick({

    autoplay: false,
    dots: true,
    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
    customPaging : function(slider, i) {
        var step = $(slider.$slides[i]).data('step');
        return step;
    },

    responsive: [{ 
        breakpoint: 768,
        settings: {
            //dots: false,
        } 
    }]
});